import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AppService } from './core/services/app.service';
import { MatDialog } from '@angular/material/dialog';
import { FestivalPopupComponent } from './shared/components/festival-popup/festival-popup.component';

@Component({
  selector: 'bit-root',
  template: ` <ngx-loading-bar
      ref="router"
      [color]="'#191920'"
    ></ngx-loading-bar>
    <router-outlet></router-outlet>`,
  styleUrls: [],
})
export class AppComponent implements OnInit {
  showPromotion = true;

  constructor(
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: string,
    private appService: AppService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId))
      document.body.style.background = 'rgb(var(--background-basic-color2))';

    this.appService.getInitialMarkets();

    this.openFestival()
  }

  openFestival() {
    // this.dialog.open(FestivalPopupComponent, {
    //   backdropClass: 'backdrop-blur-[6px]',
    // });
  }
}
